import Backdrop from '@mui/material/Backdrop';
import { styled } from '@mui/material/styles';
import React, { FC } from 'react';

import Box from '../Box/Box';
import Spinner from '../Spinner/Spinner';

const PageSpinner: FC<{ withOutBackDrop?: boolean; containerStyle?: React.CSSProperties }> = ({
  withOutBackDrop,
  containerStyle,
}) => {
  const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme?.zIndex?.drawer || 1200,
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  }));

  if (withOutBackDrop) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" style={containerStyle}>
        <Spinner width="4rem" height="4rem" />
      </Box>
    );
  }

  return (
    <StyledBackdrop open={true}>
      <Spinner width="4rem" height="4rem" />
    </StyledBackdrop>
  );
};

export default PageSpinner;
